export const fetchOrderStatus = async (orderId) => {
    const paymentApiUrl = process.env.REACT_APP_PAYMENT_API_URL || process.env.REACT_APP_API_URL;
    const response = await fetch(`${paymentApiUrl}/api/payment?orderId=${orderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch order status.');
    }

    return await response.json();
};
